// Example content shown in the "Zahvale, spomini" tab until real messages replace it.
const sampleObituary = (name, sirName, birthYear, deathDate, location) => ({
  // No id: sample cards are not clickable and their candle button is disabled.
  id: null,
  slugKey: null,
  name,
  sirName,
  birthYear,
  deathDate,
  location,
  totalCandles: 0,
});

export const SAMPLE_MESSAGES = [
  {
    id: "sample-spomin-1",
    sample: true,
    headline: "Spomin",
    background: "cream",
    sampleLabel: "To je primer Spomina",
    alignment: "left",
    authorName: "Lidija",
    Obituary: sampleObituary("Mario Danilo", "Primo", 1948, "2024-03-25", "Ljubljana"),
    message:
      "Bilo je preprosto, pa vendar nepozabno. Spomnim se najinih dolgih večerov, ko sva sedela na klopci in se smejala stvarem, ki jih nihče drug ne bi razumel.\n\nNajin svet je bil tih, a poln topline. Skupaj sva se sprehajala po poteh, ki jih zdaj prepoznavam po občutku, ne več po kraju. Tvoja bližina mi je bila zavetje, tvoj pogled dom. Včasih sva se sporekla zaradi nepomembnih stvari, a vedno končala v objemu.\n\nBil si moj človek – tista duša, ki me je znala videti točno takšno, kot sem bila. In jaz tebe. Ko pomislim nate, me zaboli, a hkrati ogreje – ker sem te imela. In ker si bil. Še vedno si – v vsakem spominu, v vsakem mojem koraku naprej. Rada sva se imela. In to ne izgine. To ostane.\n\nTvoja Lidija",
  },
  {
    id: "sample-zahvala-1",
    sample: true,
    headline: "Zahvala",
    background: "navy",
    sampleLabel: "To je primer Zahvale",
    alignment: "center",
    authorName: "Bližnji",
    Obituary: sampleObituary("Mario Danilo", "Primo", 1948, "2024-03-25", "Ljubljana"),
    message:
      "Ob boleči izgubi našega dragega\nMARIA DANILA PRIMA\nrojenega 16.04.1948, stanujočega Mala vas 33, Mesto\n\nse zahvaljujemo sorodnikom, sosedom, prijateljem in znancem za izrečena sožalja in vse darove. Zahvala gre tudi župniku Ime Priimek za opravljen obred in pogrebni službi Komunale Mesto za organizacijo pogreba. Hvala Tisti za čustven govor. Hvala vsem za spremstvo na njegovi zadnji poti.\n\nŽalujoči: vsi njegovi.",
  },
  {
    id: "sample-spomin-2",
    sample: true,
    headline: "Spomin",
    background: "cream",
    sampleLabel: "To je primer Spomina",
    alignment: "center",
    authorName: "Franci",
    Obituary: sampleObituary("Žiga Jan", "Kovačič", 1972, "2021-02-25", "Koper"),
    message:
      "Mineva 5 let, odkar nas je zapustil naš dragi mož, oče, tast, dedek in stric\nŽiga Jan KOVAČIČ\niz Kopra\n\nHvala vsem, ki postojite ob njegovem grobu ter mu prižgete svečko v spomin.\n\nŽalujoči: vsi njegovi",
  },
];

// Names for the "Zadnje dodano" list; fills the slots real messages have not taken yet.
export const SAMPLE_LIST_ITEMS = [
  { id: "sample-list-1", headline: "Posvetilo", name: "Janez Košir", authorName: "Maja K. Strehovec" },
  { id: "sample-list-2", headline: "Spomin", name: "Ana Kuralt", authorName: "Sašo Trefalt" },
  { id: "sample-list-3", headline: "Zahvala", name: "Mario Danilo Primo", authorName: "Sašo Trefalt" },
  { id: "sample-list-4", headline: "Spomin", name: "Mario Danilo Primo", authorName: "Lidija" },
  { id: "sample-list-5", headline: "Spomin", name: "Žiga Jan Kovačič", authorName: "Bližnji" },
  { id: "sample-list-6", headline: "Zahvala", name: "Damjana Popovič", authorName: "Bližnji" },
  { id: "sample-list-7", headline: "Zahvala", name: "Damjana Popovič", authorName: "Franci" },
];
